var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-scroll-to-top",class:{ show: _vm.y > 250 }},[_c('b-button',{staticClass:"btn-icon",attrs:{"variant":"primary"},on:{"click":_vm.scrollToTop}},[_c('b-icon-arrow-up')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }